// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import BaseStore from '../../../base/base-store';
import _ from 'lodash';
import customizationStore from '../../../../services/customization/customization-store';

// tslint:disable-next-line:no-var-requires no-require-imports (autogenerated)
let defaultStyleParams: IRostelecomStyleParamsStoreState = require('./default-style-params.json');

/*************************************
******************************************************************************
**********************************************************************************
*************************/

export interface IRostelecomStyleParamsStoreState {
    baseMediumDarkColor: string;
    baseLightColor: string;
    baseAccentColor: string;
    baseDarkColor: string;
    complementaryMediumDarkColor: string;
    complementaryAccentColor: string;
    neutralColor: string;
    customerLogo: string;
    defaultFontColor: string;
    fontScale: number;
    widthScale: number;
    heightScale: number;
    defaultFontFamily: string;
    defaultFontFaceSrc: string;
    fallbackFontFamily: string;
    paramsDialogShown: boolean;
    allowParamsEditing: boolean;
    playersLayoutTransitionSpeed: number;
    disableRadiumWidthScaling?: boolean;
}

export class RostelecomStylesStore extends BaseStore<IRostelecomStyleParamsStoreState> {
    public dispatcherEvents: string = 'setStyleParamsStoreState';

    public initialState: IRostelecomStyleParamsStoreState;

    private _colorsHash: { [colorKey: string]: string } = {};

    constructor() {
        super();
        this.initialState = defaultStyleParams;
        this.initialState.allowParamsEditing = true;
        this.initialState.paramsDialogShown = false;
        this.initialize('RostelecomStylesStore');
        this.getStateFromCustomizationStore();
        customizationStore.on('change', this.getStateFromCustomizationStore);
    }

    private getStateFromCustomizationStore = () => {
        const customizationState = customizationStore.getState();
        if (customizationState.loaded) {
            const ownState = this.getImmediateState();
            const mergedState = _.assign({}, ownState, customizationState.styles);
            this.updateState(mergedState);
        }
    };

    public updateState(value: any): void {
        this._colorsHash = {};
        super.updateState(value);
    }

    public getStoredColor(colorKey: string, getColorCallback: () => string): string {
        if (!this._colorsHash[colorKey]) {
            this._colorsHash[colorKey] = getColorCallback();
        }
        return this._colorsHash[colorKey];
    }
}

const store = new RostelecomStylesStore();
// tslint:disable-next-line:no-default-export (autogenerated)
export default store;
